module.exports = __webpack_public_path__ + "static/gm-40-32a709bd50fb8d3356e844fe5040e3b4.jpg";